
const state = {
  id: null,
  processing_api: '',
  short_name: '',
  title: '',
}

export const requiredFields = [
  { key: 'short_name' },
  { key: 'title' },
]

export default state
